const courseTiers = {
    "free": [
        "every-other-course-so-this-does-not-matter",
    ],
    "standard": [
        "python-in-the-cloud",
    ],
}

export default courseTiers